/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import classes from './FavoriteIconButton2.module.scss';

interface IFavoriteIconButton {
  favorite: boolean;
  loading?: boolean;
  className?: string;
  clicked: () => void;
}

const FavoriteIconButton: React.FC<IFavoriteIconButton> = ({ favorite, loading = false, className, clicked }) => {
  const renderIcon = () => {
    if (loading) {
      return <div className={classes.spinner} />;
    }

    return (
      <svg width="20" height="20" className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
          stroke="#fff"
          strokeWidth="2"
          fill={favorite ? '#e9314a' : 'rgba(54, 54, 54, 0.8)'}
        />
      </svg>
    );
  };

  return (
    <>
      <div
        className={`${classes.favoriteIconButton} ${className || ''}`}
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation();
          clicked();
        }}
        onKeyDown={() => {}}
      >
        {renderIcon()}
      </div>
    </>
  );
};

export default FavoriteIconButton;
